import { useState } from 'react';

import { TabsUI } from '../Interface';
import ProvinceDayOff from './ProvinceDayOff';

const ProvinceTabs = ({ province, setRefetchTable, selectedValues, user, disabled, canEdit }) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      id: 0,
      name: 'Tétel',
      content: (
        <ProvinceDayOff
          province={province}
          selectedValues={selectedValues}
          setRefetchTable={setRefetchTable}
          user={user}
          disabled={disabled}
          canEdit={canEdit}
        />
      ),
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
    </div>
  );
};

export default ProvinceTabs;
